import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { IOrdersGetData } from 'shared/types';
import { initialStore } from '../initial-store';
import { ILabOrder } from 'shared/interfaces/labOrder.interface';

// Actions
export const createLabOrderNote = createAction(
  'labOrders/CREATE_LAB_ORDER_NOTE',
  (payload) => ({ payload })
);

export const deleteLabOrderNote = createAction(
  'labOrders/DELETE_LAB_ORDER_NOTE',
  (payload) => ({ payload })
);

// Slice
const labOrdersSlice = createSlice({
  name: 'labOrders',
  initialState: initialStore.labOrders,
  reducers: {
    createLabOrder: (state, _data) => {
      state.isLoading = true;
    },
    updateLabOrder: (state, _data) => {
      state.isLoading = true;
    },
    getLabOrders: (state, data: PayloadAction<IOrdersGetData | undefined>) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
      if (data?.payload?.currentTab) {
        state.currentTab = data?.payload?.currentTab;
      }
    },
    setLabOrders: (state, { payload }) => {
      state.isLoading = false;
      state.labOrders = payload.result;
      state.countLabOrders = payload.count;
    },
    getLabOrder: (state, _data) => {
      state.isLoading = true;
    },
    setLabOrder: (state, { payload }) => {
      state.isLoading = false;
      state.currentLabOrder = payload;
    },
    addNewNote: (state, { payload }) => {
      if (state.currentLabOrder) {
        (state.currentLabOrder as ILabOrder).notes = [
          ...(state.currentLabOrder as ILabOrder).notes,
          payload
        ];
      }
    },
    removeNote: (state, { payload }) => {
      if (state.currentLabOrder) {
        (state.currentLabOrder as ILabOrder).notes = (
          state.currentLabOrder as ILabOrder
        ).notes.filter(({ id }: { id: string }) => id !== payload);
      }
    },
    failAction: (state) => {
      state.isLoading = false;
    }
  }
});

export const {
  createLabOrder,
  updateLabOrder,
  getLabOrders,
  setLabOrders,
  getLabOrder,
  setLabOrder,
  addNewNote,
  removeNote,
  failAction
} = labOrdersSlice.actions;

export const { reducer } = labOrdersSlice;

// Selectors
export const getLabOrdersSelector = (state: IState) =>
  state && state.labOrders.labOrders;

export const getLabOrdersCurrentTabSelector = (state: IState) =>
  state && state.labOrders.currentTab;

export const getLabOrdersCountSelector = (state: IState) =>
  state && state.labOrders.countLabOrders;

export const getLabOrdersLoadingSelector = (state: IState) =>
  state && state.labOrders.isLoading;

export const getCurrentLabOrderSelector = (state: IState) =>
  state && state.labOrders.currentLabOrder;
